const GamersSVG = ({ style, className, fill = "current" }) => (
  <svg
    style={style}
    viewBox="0 0 572 409"
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ""}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      fill="#F2F2F2"
      d="M455.308 333.161a47.941 47.941 0 01-30.984-11.362 47.96 47.96 0 01-16.305-28.697l-.039-.237.153-.183a45.944 45.944 0 006.361-10.023 32.828 32.828 0 01-6.255 5.308l-.767.511-.045-.921a48.388 48.388 0 011.778-15.585c5.565-19.566 6.517-40.577 2.829-62.449a68.509 68.509 0 01-.947-11.349 67.67 67.67 0 0116.15-43.85 67.635 67.635 0 0186.571-13.976 67.659 67.659 0 0129.123 36.54l.154.465-.454.184a35.236 35.236 0 01-10.71 2.658 45.98 45.98 0 0011.89 1.142l.422-.015.103.411a67.943 67.943 0 012.016 16.441l-.002.6a30.194 30.194 0 009.975 22.52 47.948 47.948 0 01-2.237 72.838l-.25.202-.293-.133c-6.173-2.802-10.67-5.854-13.959-9.497a46.72 46.72 0 008.736 12.664l.464.479-.576.336a47.886 47.886 0 01-24.148 6.522h-.242l-.257-.001c-12.979 0-25.28 5.02-33.788 13.796a48.305 48.305 0 01-34.467 14.661z"
    />
    <path
      fill="#3F3D56"
      d="M438.343 408.71a.87.87 0 01-.856-.744c-.036-.258-3.637-26.23-.403-60.749 2.986-31.878 12.576-77.795 41.304-115.505a.86.86 0 01.91-.312.864.864 0 01.467 1.361c-28.48 37.385-37.993 82.964-40.958 114.617-3.215 34.318.357 60.088.394 60.344a.875.875 0 01-.204.69.878.878 0 01-.654.298z"
    />
    <path
      fill="#3F3D56"
      d="M452.704 281.575a.855.855 0 01-.509-.165.866.866 0 010-1.4 119.195 119.195 0 0126.325-13.404c14.524-5.319 36.611-10.14 59.348-2.902a.868.868 0 01.6.751.868.868 0 01-.789.936.871.871 0 01-.336-.038c-22.271-7.089-43.957-2.347-58.228 2.878a117.295 117.295 0 00-25.903 13.179.852.852 0 01-.508.165z"
    />
    <path
      fill="#F2F2F2"
      d="M101.192 344.442c-8.071-.015-20.778.636-27.7 4.292a57.374 57.374 0 00-14.355 10.754 69.08 69.08 0 00-4.584 5.245 83.962 83.962 0 01-1.347-41.877 4.708 4.708 0 00-7.323-4.898C34.64 326.16 27.45 340.06 25.701 354.121c-2.227 17.917 3.018 35.971 10.308 52.493l-.002.009c-.014.074-.034.155-.054.236-.027.121-.06.243-.088.364-.047.209-.1.425-.148.635l1.18-.054c.068.033.135.06.203.094h29.565c.392-.427.757-.877 1.093-1.349 3.272-4.487 4.628-10.566 6.28-16.051a81.817 81.817 0 014.48-11.592 84.22 84.22 0 0118.287-25.038c.242-.229.492-.459.742-.681 1.271-1.17 3.242-2.734 5.169-4.203a2.525 2.525 0 00.867-2.818 2.525 2.525 0 00-2.391-1.724z"
    />
    <path
      fill="#9E616A"
      d="M300.815 65.611a7.872 7.872 0 01-4.639 10.02c-.428.16-.869.282-1.318.364l-4.468 27.364-10.481-9.68 5.85-24.501a7.9 7.9 0 016.92-8.67 7.688 7.688 0 018.136 5.103z"
    />
    <path
      fill="#6C63FF"
      d="M223.464 127.616s8.134-10.751 37.654-10.456l16.755-6.089 3.829-35.109 13.402 3.192-1.914 43.407-28.719 16.597-37.654 7.66-3.353-19.202z"
    />
    <path
      fill="#9E616A"
      d="M178.104 392.287l7.733 3.296 16.391-28.264-11.413-4.865-12.711 29.833zM242.006 399.607l8.405-.001 3.999-32.429-12.406.001.002 32.429z"
    />
    <path
      fill="#2F2E41"
      d="M241.71 408.377l25.848-.001v-.327a10.061 10.061 0 00-10.06-10.063h-.001l-4.722-3.583-8.809 3.584h-2.256v10.39zM173.403 397.902l23.779 10.135.128-.3a10.067 10.067 0 00-5.311-13.203h-.001l-2.939-5.148-9.508-.158-2.076-.885-4.072 9.559zM250.252 207.682l12.774 77.803-3.476 11.594 4.562 8.211-6.7 72.114 2.72 5.988-7.598 4.687h-15.462l-.82-65.285-3.819-9.585v-5.283l-7.775-39.809-1.431 45.537-2.262 9.6 1.9 6.836-2.482 4.788-21.272 45.687h-17.337l1.34-10.332c-3.106-1.573 4.664-6.171 5.411-9.572l-2.553-5.745 2.553-10.852 2.34-21.204-2.468-44.76 1.161-60.274 20.281-15.512 40.413 5.368z"
    />
    <path
      fill="#9E616A"
      d="M219.142 105.219c9.676 0 17.52-7.845 17.52-17.524 0-9.678-7.844-17.524-17.52-17.524-9.677 0-17.521 7.846-17.521 17.524 0 9.679 7.844 17.524 17.521 17.524zM188.698 239.955a6.894 6.894 0 00-1.225-8.315 6.91 6.91 0 00-2.546-1.564l-.042-24.506-10.617 7.029 1.667 22.194a6.934 6.934 0 0012.763 5.162z"
    />
    <path
      fill="#6C63FF"
      d="M187.717 131.523l-4.743-4.573-3.484 2.516s-3.429 4.115-6.171 16.459c-2.743 12.343 0 80.235 0 80.235l15.084-2.057-2.057-35.66 6.171-30.175-4.8-26.745z"
    />
    <path
      fill="#6C63FF"
      d="M180.713 128.066l15.98-7.635 10.85-10.065 19.784-.148 6.382 8.298 16.849 5.724-2.808 58.11 1.914 4.468s-1.334 1.205-1.943 1.879c-.61.674.842 6.318.842 6.318l.818 6.139-2.27 1.623 2.951 3.486.733 5.496s-51.512-12.806-61.246 8.409c-.514 1.12.752-9.834.752-9.834l1.267-8.019-1.257-7.198-1.914-1.915 3.211-3.212-2.059-15.24-8.836-46.684z"
    />
    <path
      fill="#FFB6B6"
      d="M347.511 391.943h-9.483l-4.512-36.585h13.995v36.585z"
    />
    <path
      fill="#2F2E41"
      d="M352.517 408.377h-6.801l-1.214-6.422-3.109 6.422h-18.037a4.054 4.054 0 01-3.833-5.378 4.055 4.055 0 011.53-2.015l14.403-9.95v-6.492l15.15.904 1.911 22.931z"
    />
    <path
      fill="#FFB6B6"
      d="M439.737 373.124l-8.156 4.838-22.54-29.165 12.039-7.141 18.657 31.468z"
    />
    <path
      fill="#2F2E41"
      d="M452.423 384.705l-5.849 3.47-4.319-4.904.601 7.11-15.514 9.202a4.054 4.054 0 01-6.04-2.67 4.062 4.062 0 01.288-2.513l7.315-15.907-3.311-5.584 13.492-6.952 13.337 18.748z"
    />
    <path
      fill="#FFB6B6"
      d="M343.279 158.021l-4.608 29.384 43.779.575-5.761-28.231-33.41-1.728z"
    />
    <path
      fill="#2F2E41"
      d="M338.502 187.033l-12.504 30.332-.911 81.114 10.671 77.447h11.808l4.838-76.184 11.9-52.129 11.737 54.521 36.493 53.366h17.932l-32.968-58.807-3.816-64.06s2.378-27.176-9.792-43.212l-2.963-8.56-42.425 6.172z"
    />
    <path
      fill="#FFB6B6"
      d="M399.75 209.178a8.634 8.634 0 01-5.579-4.728 8.64 8.64 0 01.042-7.313l-18.624-60.732 13.699-2.717 17.033 59.531a8.689 8.689 0 01-6.571 15.959z"
    />
    <path
      fill="#740A76"
      d="M377.656 179.355l-32.731-15.264a3.947 3.947 0 01-3.739-2.973c-1.618-6.407-5.177-13.528-3.289-30.158a24.25 24.25 0 0117.943-20.673 24.224 24.224 0 019.615-.541 24.255 24.255 0 0120.024 30.179c-3.799 14.429-3.391 29.858-3.824 35.788a3.938 3.938 0 01-3.915 3.643l-.084-.001z"
    />
    <path
      fill="#FFB6B6"
      d="M307.184 77.356a8.423 8.423 0 01-.639 1.17l15.651 36.706 9.62 1.18.116 14.754-17.233-.434a6.433 6.433 0 01-6.06-4.79l-11.6-43.89a8.442 8.442 0 01-6.009-7.488 8.448 8.448 0 019.861-8.929 8.442 8.442 0 016.854 6.724 8.453 8.453 0 01-.561 4.997z"
    />
    <path
      fill="#740A76"
      d="M323.773 113.924a3.621 3.621 0 012.884-.877l18.004 2.438a10.052 10.052 0 0110.183 9.897 10.054 10.054 0 01-9.867 10.211l-17.996 2.902a3.609 3.609 0 01-3.847-2.025 3.604 3.604 0 01-.348-1.503l-.234-18.286a3.628 3.628 0 011.221-2.757zM374.755 151.788a3.608 3.608 0 01-1.841-2.387l-4.089-17.707a10.059 10.059 0 015.653-13.026 10.051 10.051 0 0113.04 5.618l9.079 15.808a3.631 3.631 0 01.277 3.003 3.623 3.623 0 01-2.092 2.171l-17.017 6.687a3.62 3.62 0 01-3.01-.167z"
    />
    <path
      fill="#FFB6B6"
      d="M374.029 103.501c8.97-4.904 12.267-16.153 7.363-25.126-4.903-8.972-16.15-12.27-25.12-7.365-8.971 4.905-12.267 16.154-7.364 25.127 4.904 8.972 16.151 12.269 25.121 7.364z"
    />
    <path
      fill="#2F2E41"
      d="M352.417 79.813l-11.914-.067c-.283-2.707.922-5.4 2.677-7.48s4.028-3.647 6.272-5.187c2.278-1.564 4.638-3.163 7.346-3.71 2.27-.457 4.616-.14 6.909.18l9.124 1.268c3.338.465 6.831.99 9.542 2.992 3.667 2.708 2.73 8.96 6.248 11.857 10.625 8.753 6.323 16.397 6.521 24.376l-38.521 4.041c-1.393.24-2.821.199-4.198-.122-1.349-.412-2.585-1.529-2.685-2.935-.111-1.572 1.136-2.858 2.148-4.065a18.997 18.997 0 001.637-21.471l-1.106.323zM214.659 104.361l-.223-.496.085.006.138.49zM201.134 70.968a4.876 4.876 0 013.055-1.32c1.133.036 2.282 1.06 2.047 2.169a18.005 18.005 0 0121.667-8.127c2.816.994 5.577 2.982 6.224 5.898.063.765.291 1.508.669 2.176a2.482 2.482 0 002.644.67l.028-.008a.829.829 0 011 1.169l-.797 1.486a6.383 6.383 0 003.042-.065.829.829 0 01.879 1.288 14.424 14.424 0 01-11.496 5.91c-3.183-.02-6.399-1.117-9.497-.385a8.246 8.246 0 00-6.353 8.024 8.258 8.258 0 00.804 3.56c-.952-1.041-2.792-.795-3.765.226a5.157 5.157 0 00-1.128 3.952c.26 2.147.897 4.231 1.882 6.155a18.39 18.39 0 01-16.89-12.582 18.4 18.4 0 015.985-20.196z"
    />
    <path
      fill="#CCC"
      d="M549.235 409H.832a.759.759 0 010-1.52h548.403a.77.77 0 01.539.222c.071.07.127.154.165.247a.745.745 0 010 .582.76.76 0 01-.704.469z"
    />
  </svg>
);

export default GamersSVG;
